module.exports = __webpack_public_path__ + "img/shipo-icon-close-circle.eddc806b.svg";